import React from 'react';
import PropTypes from 'prop-types';

import { TrendBase, TrendRoot, UpIcon, DownIcon, Value } from './Trend.styles';
import { TextMedium } from 'lib/common/text';

export const Trend = ({ value, textComponent }) => {
    if (value === undefined) {
        return null;
    }
    const isNegative = value < 0;
    const formattedValue = `${Math.abs(value)}`;
    const TextValue = Value.withComponent(textComponent);
    return (
        <TrendBase isNegative={isNegative} data-testid="trend">
            <TrendRoot>
                <TextValue isNegative={isNegative} className="value">
                    {formattedValue}
                </TextValue>

                <TextMedium className="unit">%</TextMedium>

                {isNegative ? <DownIcon className="downIcon" /> : <UpIcon className="upIcon" />}
            </TrendRoot>
        </TrendBase>
    );
};

Trend.displayName = 'Trend';

Trend.propTypes = {
    value: PropTypes.number,
    fontSize: PropTypes.string,
};

Trend.defaultProps = {};
